import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface ISegment {
  category: string;
  startTime?: string;
  startTimeLocal?: string;
  location?: {
    latitude: number;
    longitude: number;
    location_time: string;
    speed: any;
  };
  timezone?: string;
  address?: string;
  endTime?: string;
  endTimeLocal?: string;
  durationInSeconds?: number;
  durationHuman?: string;
  geolocations?: Array<{
    latitude: number;
    longitude: number;
    location_time: string;
    speed: number;
  }>;
  breaks?: Array<any>;
  site?: {
    name: string;
    radius: number;
    location: {
      latitude: number;
      longitude: number;
      location_time?: string;
      speed?: number;
    };
    id?: number;
    has_custom_geofence?: boolean;
    geofence_coordinates?: [number, number][];
  };
  distance?: number;
  distanceInKm?: number;
  distanceInMiles?: number;
}

export interface ISegmentedTimesheet {
  status: any;
  message: string;
  payload: {
    segments: ISegment[];
    drivingDistance: number;
    totalDuration: number;
    durationHuman: string;
    timesheet: number;
    job: string;
    task: any;
    clockInTime: string;
    clockInTimeLocal: string;
    clockOutTime: string;
    clockOutTimeLocal: string;
    mileage: number;
    totalBreakDuration: number;
  };
}

const fetchSegmentedTimesheetById = (timesheetId: string): Promise<ISegmentedTimesheet> => {
  const newEndpoints = endpoints.timesheet.segmented.replace('{id}', timesheetId);
  return http().get(newEndpoints);
};

export function useFetchSegmentedTimesheetById(id: string): UseQueryResult<ISegmentedTimesheet> {
  return useQuery({
    queryKey: ['fetchSegmentedTimesheetById', id],
    queryFn: () => fetchSegmentedTimesheetById(id!),
    enabled: !!id,
  });
}
